import { render } from "./ModalChat.vue?vue&type=template&id=33fd9ada&scoped=true"
import script from "./ModalChat.vue?vue&type=script&lang=js"
export * from "./ModalChat.vue?vue&type=script&lang=js"

import "./ModalChat.vue?vue&type=style&index=0&id=33fd9ada&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fd9ada"]])

export default __exports__